/**
 * `/settings` — the account surface.
 *
 * One `RouteObject`, so the file is `account.route.tsx` (singular); the
 * three-route aggregate beside it is `settings.routes.tsx` (plural), and the
 * importer knows the shape from the name.
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** The page component owns its reads, so there is one
 * cache and one invalidation story.
 */
import type { RouteObject } from 'react-router-dom';

export const accountSettingsRoute: RouteObject = {
  path: 'settings',
  lazy: async () => {
    const { AccountSettingsPage } = await import('./Account');
    return { Component: AccountSettingsPage };
  },
};
